const getBitrix24TopLevelDomain = lang => {
  if (lang == 'de' || lang == 'es' || lang == 'ru') return lang;
  else if (lang == 'pt') return 'com.br';

  return 'com';
};

export default getBitrix24TopLevelDomain;
